import { render, staticRenderFns } from "./SelectBrigades.vue?vue&type=template&id=0eb6e57a&"
import script from "./SelectBrigades.vue?vue&type=script&lang=js&"
export * from "./SelectBrigades.vue?vue&type=script&lang=js&"
import style0 from "./SelectBrigades.vue?vue&type=style&index=0&id=0eb6e57a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports